<h3 mat-dialog-title >
    <b>Estrutura Familiar</b> 
 </h3>
 

<div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
    <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
        <mat-label>Nome</mat-label>
        <input 
            matInput 
            placeholder="Nome"
            aria-label="Nome" 
            [formControl]="nome" 
            required
            maxlength="255">
    </mat-form-field>
</div>
<div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
     <mat-form-field appearance="outline" floatLabel="always" style="width: 100%" fxFlex="100">
        <mat-label>Parentesco</mat-label>
        <mat-select
             [(value)]="model.parentesco_id"
             [formControl]="parentesco_id" required>
             <mat-option value="">SELECIONE</mat-option>
             <mat-option *ngFor="let parentesco of listaParentesco"
                 [value]="parentesco.id">{{parentesco.nome}}</mat-option>
        </mat-select>
        <mat-spinner diameter="20" *ngIf="loadingSpinnerParentesco"></mat-spinner> 
     </mat-form-field>
 </div>
<div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
    <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
        <mat-label>Data de Nascimento</mat-label>
        <input
            matInput
            [matDatepicker]="picker_1" 
            [formControl]="data_nascimento" 
            name="data_nascimento" 
            placeholder="Data de Nascimento"
            aria-label="Data de Nascimento"
            required>
        <mat-datepicker-toggle matSuffix [for]="picker_1"></mat-datepicker-toggle>
        <mat-datepicker #picker_1></mat-datepicker>
    </mat-form-field>
</div>
<div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
     <mat-form-field appearance="outline" floatLabel="always" style="width: 100%" fxFlex="100">
        <mat-label>Sexo</mat-label>
        <mat-select
            [(value)]="model.sexo"
            [formControl]="sexo" 
            required
        >
            <mat-option value="">SELECIONE</mat-option>
            <mat-option [value]="'M'">Masculino</mat-option>
            <mat-option [value]="'F'">Feminino</mat-option>
        </mat-select>
     </mat-form-field>
 </div>

 <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">

    <mat-form-field appearance="outline" floatLabel="always" style="width: 100%" fxFlex="100">
        <mat-label>Estado Civil</mat-label>
        <mat-select
            [(value)]="model.estado_civil_id"
            [formControl]="estado_civil"
            required
        >
            <mat-option value="">SELECIONE</mat-option>
            <mat-option *ngFor="let estadoCivil of listEstadoCivil" [value]="estadoCivil.id">{{estadoCivil.nome}}</mat-option>
        </mat-select>
        <mat-spinner diameter="20" *ngIf="loadingSpinnerEstadoCivil"></mat-spinner>
    </mat-form-field>
 </div>
 
<div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
    <mat-form-field appearance="outline" floatLabel="always" fxFlex="100" style="width: 100%">
        <mat-label>Profissão</mat-label>
        <input 
            matInput 
            placeholder="Digite o nome da Profissão" 
            aria-label="Profissão"  
            [formControl]="profissao_id" 
            name="profissao_id"             
            [matAutocomplete]="auto">
        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn"  (optionSelected)='getProfissao($event.option.value)'>
            <mat-option *ngFor="let profissao of filteredOptions | async" [value]="profissao">
                <span> {{profissao.nome}}</span>
            </mat-option>
        </mat-autocomplete>
        <mat-icon matSuffix class="secondary-text" *ngIf="!loadingSpinner">account_circle</mat-icon>
        <mat-spinner diameter="20" *ngIf="loadingSpinner"></mat-spinner>
    </mat-form-field>
</div>
<div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
    <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
        <mat-label>Valor da Renda</mat-label>
        <input 
            matInput 
            placeholder="Valor da Renda"
            [formControl]="renda"
            currencyMask [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"
            maxlength="50">
    </mat-form-field>
</div>

 <div mat-dialog-actions style="text-align: center; margin-top: 20px;">
     <button 
         mat-button 
         tabindex="2" 
         (click)="onNoClick()">
         Cancelar
     </button>
     <button 
         mat-button 
         [disabled]="isInvalidForm()" 
         (click)="salvar()" 
         tabindex="-1">
         Confirmar
     </button>
 </div>